import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fb3d233"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "image-popup"
}
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "popup-description" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ImagePopup',
  props: {
  showPopup: Boolean,
  selectedImage: String,
  selectedDescription: String,
},
  emits: ["close-popup"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const closePopup = () => {
  emit("close-popup");
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (__props.showPopup)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            class: "close-button",
            onClick: closePopup,
            transparent: "",
            elevation: 0
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { small: "" }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-close-circle-outline")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("img", {
            src: __props.selectedImage,
            alt: "popup_image"
          }, null, 8, _hoisted_3),
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.selectedDescription), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})